// Shown to a signed-in client-side user (client, collaborator, planner) whose account has no wedding.
//
// Replaces the old "create your wedding" wizard (audit 2026-09-27 H5 + owner decision
// 2026-09-28: clients may NOT create weddings themselves — weddings are created by staff
// or the booking funnel). The wizard's POST /api/weddings was refused for clients anyway.
// Contact copy uses the public venue line only (never a staff member's personal number).
//
// force-v2 Part 6: v2 skin ([data-ui="v2"], his `.tile` / `.state` / `.btn`) — every client-side
// user is on the v2 portal, so this is no longer a classic-looking card — and role-fitting copy
// (../../v2/lib/noLinkedBooking.ts).
import { CalendarHeart, MessageCircle, Phone } from "lucide-react";
import { useAuth } from "@/hooks/use-auth";
import { noBookingCopy } from "@/v2/lib/noLinkedBooking";
import "@/v2/v2.css";
import "@/v2/prototype.css";

const VENUE_LINE_DISPLAY = "+91 94467 76666";
const VENUE_LINE_WA = "919446776666";

export default function NoLinkedBooking() {
  const { user, logout } = useAuth();
  const copy = noBookingCopy((user as { role?: string } | null)?.role);
  return (
    <div data-ui="v2" className="v2-root v2-client v2-nolink"
      style={{ minHeight: "100dvh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <section className="tile" style={{ maxWidth: 460, width: "100%" }} aria-labelledby="v2-nolink-t">
        <div className="state">
          <span className="arch-ico" aria-hidden><CalendarHeart /></span>
          <b id="v2-nolink-t">{copy.title}</b>
          <p>{copy.body}</p>
          <div style={{ display: "flex", flexDirection: "column", gap: 10, width: "100%", marginTop: 8 }}>
            <a className="btn btn-primary btn-block" href={`https://wa.me/${VENUE_LINE_WA}`} target="_blank" rel="noopener noreferrer">
              <MessageCircle aria-hidden />WhatsApp us
            </a>
            <a className="btn btn-secondary btn-block" href={`tel:+${VENUE_LINE_WA}`}>
              <Phone aria-hidden />Call {VENUE_LINE_DISPLAY}
            </a>
            <button type="button" className="btn btn-ghost btn-block" onClick={() => { void logout(); }}>
              Sign out
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
